export const ProcedureCodes = [
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "70551",
        display: "Magnetic resonance (eg, proton) imaging, brain (including brain stem)", 
        serviceDescription: "Magnetic Resonance Imaging (MRI) of the brain (including brain stem)",
        unitPrice: 266.0,
        revenue: {
            code: "0611",
            display: "Magnetic Resonance Technology (MRT) - Brain/brain stem"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "96413",
        display: "Injection and Intravenous Infusion Chemotherapy and Other Highly Complex Drug or Highly Complex Biologic Agent Administration",
        serviceDescription: "Chemotherapy administration, intravenous infusion technique",
        unitPrice: 181.11,
        revenue: {
            code: "0972",
            display: "Professional Fees: Radiology - diagnostic"
        }
    },
    {
        system: "http://www.cms.gov/Medicare/Coding/HCPCSReleaseCodeSets",
        code: "J9312",
        display: "Injection, rituximab, 10 mg",
        serviceDescription: "Injection of 10 mg of Rituximab",
        unitPrice: 50,
        revenue: {
            code: "0260",
            display:  "IV Therapy - General"
        }
    },
    {
        system: "http://www.cms.gov/Medicare/Coding/HCPCSReleaseCodeSets",
        code: "J9260",
        display: "Methotrexate sodium, 50 mg",
        serviceDescription: "Administration of 50mg of Methotrexate",
        unitPrice: 50,
        revenue: {
            code: "0261",
            display: "IV Therapy - Infusion pump"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "27447",
        display: "ARTHROPLASTY, KNEE, CONDYLE AND PLATEAU; MEDIAL AND LATERAL COMPARTMENTS WITH OR WITHOUT PATELLA RESURFACING (TOTAL KNEE ARTHROPLASTY)",
        serviceDescription: "Total knee arthroplasty",
        unitPrice: 12500.0,
        revenue: {
            code: "0360",
            display: "Operating Room Services - General Classification"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "99221",
        display: "Initial hospital inpatient or observation care, per day, for the evaluation and management of a patient, which requires a medically appropriate history and/or examination and straightforward or low level medical decision making. When using total time on the date of the encounter for code selection, 40 minutes must be met or exceeded.",
        serviceDescription: "Initial hospital inpatient or observation care",
        unitPrice: 250.0,
        revenue: {
            code: "0510",
            display: "Clinic - General Classification"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "85025",
        display: "Blood count; complete (CBC), automated (Hgb, Hct, RBC, WBC and platelet count) and automated differential WBC count",
        serviceDescription: "Laboratory blood tests (CBC)",
        unitPrice: 480.0,
        revenue: {
            code: "0305",
            display: "Lab - Hematology"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "93000",
        display: "Electrocardiogram, routine ECG with at least 12 leads; with interpretation and report",
        serviceDescription: "Electrocardiogram (EKG)",
        unitPrice: 310.0,
        revenue: {
            code: "0730",
            display: "EKG / Cardiology"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "96360",
        display: "Intravenous infusion, hydration; initial, 31 minutes to 1 hour",
        serviceDescription: "IV hydration therapy",
        unitPrice: 280.0,
        revenue: {
            code: "0260",
            display: "IV Therapy"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "97162",
        display: "Physical therapy evaluation, moderate complexity, typical time with patient 30 minutes",
        serviceDescription: "Post-op physical therapy evaluation",
        unitPrice: 350.0,
        revenue: {
            code: "0420",
            display: "Physical Therapy"
        }
    },
    {
        system: "http://www.cms.gov/Medicare/Coding/HCPCSReleaseCodeSets",
        code: "J1885",
        display: "Injection, ketorolac tromethamine, per 15 mg",
        serviceDescription: "Ketorolac injection",
        unitPrice: 28.0,
        revenue: {
            code: "0631",
            display: "Drugs Requiring Detailed Coding"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "01402",
        display: "Anesthesia for open or surgical arthroscopic procedures on knee joint; total knee arthroplasty",
        serviceDescription: "Anesthesia",
        unitPrice: 1950.0,
        revenue: {
            code: "0001",
            display: "Anesthesia services"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "99100",
        display: "Anesthesia for patient of extreme age, younger than 1 year and older than 70 (List separately in addition to code for primary anesthesia procedure)",
        serviceDescription: "Anesthesia",
        unitPrice: 180.0,
        revenue: {
            code: "0001",
            display: "Anesthesia services"
        }
    },
    {
        system: "http://www.ama-assn.org/go/cpt",
        code: "99140",
        display: "Anesthesia complicated by emergency conditions (specify) (List separately in addition to code for primary anesthesia procedure)",
        serviceDescription: "Anesthesia complicated by emergency conditions",
        unitPrice: 120.0,
        revenue: {
            code: "0001",
            display: "Anesthesia services"
        }
    }
];